import { css } from 'styled-components6';
import { PluginContent } from 'rwl-shared/dist/models';
import { ReactImageGalleryItem } from 'react-image-gallery';
import { MediaType } from 'rwl-shared/dist/utils/media';
import { IMAGE_ORIENTATION } from 'rwl-shared/dist/models/Media';

const dateTimeLongFormat = new Intl.DateTimeFormat('en', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
});

const dateTimeShortFormat = new Intl.DateTimeFormat('en', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
});

export function dateFormat(timeInMillis: number, longMonth?: boolean) {
    return longMonth
        ? dateTimeLongFormat.format(timeInMillis)
        : dateTimeShortFormat.format(timeInMillis);
}

export interface RWLImageGalleryItem extends ReactImageGalleryItem {
    content: PluginContent;
    type: MediaType;
    id: string;
    orientation?: IMAGE_ORIENTATION;
    isCover?: boolean;
    isBeforeMedia?: boolean;
    isAfterMedia?: boolean;
}

export const contentMediaToImageGalleryItems = (
    content: PluginContent[]
): RWLImageGalleryItem[] => {
    if (content.length === 0) {
        return [];
    }
    return content
        .map((c) =>
            c.media.map((m) => ({
                original: m.sourceUrl,
                thumbnail: m.thumbnailUrl,
                content: c,
                type: m.type,
                id: m.id,
                orientation: m.orientation,
                isCover: m.isCover,
                isBeforeMedia: m.isBeforeMedia,
                isAfterMedia: m.isAfterMedia,
            }))
        )
        .reduce((acc, val) => acc.concat(val));
};

export const rwlImageGalleryStyles = css`
    .image-gallery-svg {
        color: #fff;
        height: 3em;
    }

    .image-gallery-icon {
        filter: none;
    }

    .image-gallery-icon:hover .image-gallery-svg {
        transform: none;
    }

    .image-gallery-icon:focus {
        outline: none;
    }

    button.image-gallery-bullet {
        padding: 3px;
    }

    button.image-gallery-bullet:hover,
    button.image-gallery-bullet.active:hover {
        background: #fff;
        border: 1px solid #fff;
    }

    button.image-gallery-left-nav,
    button.image-gallery-right-nav {
        background-color: rgba(0, 0, 0, 0.2);
        position: absolute;
        top: 50%;
        border: none;
        padding: 0;
        & svg {
            width: 45.5px;
        }
    }

    button.image-gallery-left-nav:focus,
    button.image-gallery-right-nav:focus {
        position: absolute;
        top: 50%;
        border: none;
    }

    button.image-gallery-left-nav:hover,
    button.image-gallery-right-nav:hover {
        position: absolute;
        top: 50%;
        border: none;
    }

    button.image-gallery-left-nav:active,
    button.image-gallery-right-nav:active {
        position: absolute;
        top: 50%;
        border: none;
    }

    button.image-gallery-right-nav {
        border-radius: 6px 0 0 6px;
    }

    button.image-gallery-left-nav {
        border-radius: 0 6px 6px 0;
    }

    .rwlPopup & {
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }
`;
